export default {"src":"/_next/static/media/emailShare.245aa511.svg","height":13,"width":19,"blurWidth":0,"blurHeight":0};